// frontend/src/router/index.tsx
// FIXED: Handle profile route conflicts by using shared route

import { Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import LoadingSpinner from "@/components/LoadingSpinner";
import ProtectedRoute from "@/components/auth/ProtectedRoute";
import SmartDashboardRedirect from "@/components/SmartDashboardRedirect";
import UserProfile from "@/pages/UserProfile";

// Import organized routes
import { authRoutes } from "./routes/authRoutes";
import { adminRoutes } from "./routes/adminRoutes";
import { providerRoutes } from "./routes/providerRoutes";
import { customerRoutes } from "./routes/customerRoutes";
import { bookingRoutes } from "./routes/bookingRoutes";
import { quickBookingRoutes } from "./routes/quickBookingRoutes";
import { areasRoutes } from "./routes/areasRoutes"; // ✅ NEW: Areas routes for unified management
import { providerServiceRoutes } from "./routes/providerServiceRoutes"; // ✅ ADD: Import provider service routes

const AppRouter: React.FC = () => {
  const { isLoading } = useAuth();

  if (isLoading) {
    return <LoadingSpinner />;
  }

  return (
    <Routes>
      {/* Authentication Routes */}
      {authRoutes}

      {/* Quick Booking Routes (Public) */}
      {quickBookingRoutes}

      {/* Main Dashboard Route */}
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <SmartDashboardRedirect />
          </ProtectedRoute>
        }
      />

      {/* CRITICAL: Booking Routes MUST come BEFORE role-specific routes */}
      {bookingRoutes}

{/* This ensures /provider-areas works for both admin and provider */}
{areasRoutes}

{/* This ensures the unified /provider-services route with automatic layout detection works */}
{providerServiceRoutes}


      {/* 
        🔧 SOLUTION: Shared /profile route for all roles
        This prevents conflicts between admin, provider, and customer profile routes
        All roles use the same UserProfile component for account settings
      */}
      <Route
        path="/profile"
        element={
          <ProtectedRoute>
            <UserProfile />
          </ProtectedRoute>
        }
      />

      {/* Role-specific Routes (excluding /profile routes which are handled above) */}
      {adminRoutes}
      {providerRoutes}
      {customerRoutes}

     

      {/* Fallback Route */}
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
};

export default AppRouter;